import React, { useEffect, useRef, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import SeoForm, { SeoFormRef, submitSEOData } from '../../components/common/SEOForm';
import { SeoFormData } from '../../interfaces/seo';
import { useForm } from 'react-hook-form';
import Button from '../../components/UI/Buttons/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { showToastNotification } from '../../utility/helper';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';

const AddSEO: React.FC = () => {

    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const { id } = useParams<{ id: string }>();
    const { handleSubmit } = useForm({ mode: 'onBlur' });
    const seoFormRef = useRef<SeoFormRef>(null);
    const navigate = useNavigate();
    const [seoData, setSeoData] = useState<SeoFormData>({
        entityType: 'recipe',
    });

    useEffect(() => {
        if (id) {
            getSeoDetails();
        }
    }, [id]);

    const getSeoDetails = async () => {
        try {
            setLoadingButton(true);
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + 'seo/' + id, { method: 'GET' });
            setSeoData(response);
        } catch (error: any) {
            console.error('Failed to fetch seoList:', error.message);
        } finally {
            setLoadingButton(false);
        }
    }

    const onSubmit = async () => {
        setLoadingButton(true);

        try {
            if (seoFormRef.current) {
                const isValid = await seoFormRef.current.triggerValidation();
                const seoFormData = seoFormRef.current.getFormData();

                if (!isValid) {
                    showToastNotification('danger', 'SEO form has validation errors');
                    return;
                }

                const newSeoData = {
                    ...seoFormData,
                    entityId: '',
                    entityType: 'page',
                };

                await submitSEOData(newSeoData, seoData.id);
                showToastNotification('success', 'SEO data saved successfully');
                navigate('/seo');
            }
        } catch (error) {
            console.error('Error submitting SEO data:', error);
            showToastNotification('danger', 'Failed to submit SEO data');
        } finally {
            setLoadingButton(false);
        }
    };

    return (
        <Layout>
            <h1 className="app-page-title">{id ? "Update SEO Page" : "Add SEO Page"}</h1>
            <div className="row">
                <div className="col-lg-12">
                    <div className="app-card app-card-settings shadow-sm p-4">
                        <div className="app-card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <h3> {seoData?.id ? "Update SEO Page" : "Add SEO Page"} </h3>
                                <SeoForm
                                    ref={seoFormRef}
                                    entityId={seoData?.id || ''}
                                    entityType="page"
                                    initialData={seoData}
                                    isRequired={true}
                                    isPagePath={true}
                                />
                                <div className="col-12 text-end mt-3 ">
                                    <Button
                                        loading={loadingButton}
                                        className="btn btn-primary text-white px-5"
                                        type="submit"
                                        text={seoData?.id ? "Update" : "Save"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default AddSEO